export default function() {
	return function filter(incident) {
		if (!incident) { return ''; }
		if (incident.extra_data && incident.extra_data.__QA_METADATA) {
			return 'QA/' + incident.extra_data.__QA_METADATA.display_name;
		}
        if (incident.version === 'qa_assist') {
            return 'Assist/' + incident.extra_data.original_incident.entity.name;
        }
		switch(incident.version) {
			case 'ug_pump_station':
			case 'ug_pump_station_after_hours':
				return 'Pump station';

			case 'loveland_water_distribution_after_hours':
			case 'loveland_water_meter_after_hours':
				return 'Water';
			case 'loveland_sewer_after_hours':
				return 'Sewer';

			case 'ug_sewer_on_call':
				return 'Supervisor';
			case 'ug_sewer_night_crew':
				return 'Crew';

			case 'ug_sewer_weekday_pm':
			case 'ug_sewer_friday_pm':
			case 'ug_sewer_saturday_am':
			case 'ug_sewer_saturday_pm':
			case 'ug_sewer_sunday_am':
			case 'ug_sewer_sunday_pm':
				return 'Crew';
			case 'ug_sewer_on_call_supervisor_phase_2':
				return 'Supervisor'
			case 'ug_sewer_phase2_generic':
				return 'Manual'

			case 'durham_sewer':
				return 'Sewer';
			case 'durham_water':
				return 'Water';
			case 'durham_meter_services_ah':
				return 'Meter services';

			case 'olathe_sewer_generic':
			case 'olathe_sewer_a':
			case 'olathe_sewer_b':
			case 'olathe_sewer_c':
			case 'olathe_sewer_generic_v2':
			case 'olathe_sewer_mon':
			case 'olathe_sewer_tue':
			case 'olathe_sewer_wed':
			case 'olathe_sewer_thu':
			case 'olathe_sewer_fri':
			case 'olathe_sewer_sat':
			case 'olathe_sewer_sun':
				return 'Sewer';
			case 'olathe_water_generic':
			case 'olathe_water_a':
			case 'olathe_water_b':
			case 'olathe_water_c':
			case 'olathe_water_generic_v2':
			case 'olathe_water_mon':
			case 'olathe_water_tue':
			case 'olathe_water_wed':
			case 'olathe_water_thu':
			case 'olathe_water_fri':
			case 'olathe_water_sat':
			case 'olathe_water_sun':
				return 'Water';

			case 'springfield_sewer_after_hours':
				return 'Sewer';

			case 'arvada_sewer_after_hours':
				return 'Sewer';
			case 'arvada_water_after_hours':
				return 'Water';

			case 'scmwd_after_hours':
				return 'Water';

			case 'klamath_falls_water_dist_ah':
				return 'Water';
			case 'klamath_falls_water_billing_ah':
				return 'Billing';
			case 'klamath_falls_sewer_collections_ah':
				return 'Collections';
			case 'klamath_falls_sewer_treatment_ah':
				return 'Treatment';
			case 'klamath_falls_streets_ah':
				return 'Streets';
			case 'klamath_falls_traffic_ah':
				return 'Traffic';

			case 'alliance_ralls_co_sewer_ah':
			case 'alliance_ralls_co_sewer_daytime':
				return 'Sewer';
			case 'alliance_ralls_co_water_ah':
			case 'alliance_ralls_co_water_daytime':
				return 'Water';

			case 'oakland_general_investigate_ah':
				return 'Investigation';
			case 'oakland_general_field_service_ah':
				return 'Field response';

			case 'daupler_qa_durham':
				return 'Durham';
			case 'daupler_qa_oakland_general':
				return 'Oakland General';
			case 'daupler_qa_olympia':
				return 'Olympia';

			case 'greeley_sewer_ah':
				return 'Sewer';
			case 'greeley_water_ah':
				return 'Water';

			case 'lake_havasu_water_ah':
			case 'lake_havasu_water_ah_default':
			case 'lake_havasu_water_ah_backup':
				return 'Water';

			case 'santa_barbara_general_ah':
				return 'General';
			case 'santa_barbara_water_ah':
				return 'Water';

			case 'olympia_general_ah':
				return 'Olympia';

			case 'generic_sewer_v1':
				return 'Sewer';
			default:
				if (incident.entity)
					return incident.entity.name;
		}
	}
}
